// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistoryReadResponseData } from './HistoryReadResponseData';
import {
    HistoryReadResponseDataFromJSON,
    HistoryReadResponseDataFromJSONTyped,
    HistoryReadResponseDataToJSON,
    HistoryReadResponseDataToJSONTyped,
} from './HistoryReadResponseData';
import type { HistoryReadResponseMeta } from './HistoryReadResponseMeta';
import {
    HistoryReadResponseMetaFromJSON,
    HistoryReadResponseMetaFromJSONTyped,
    HistoryReadResponseMetaToJSON,
    HistoryReadResponseMetaToJSONTyped,
} from './HistoryReadResponseMeta';

/**
 * Historical data response for a function (returns all value variables)
 * @export
 * @interface HistoryReadResponse
 */
export interface HistoryReadResponse {
    /**
     * Overall status code of the operation (e.g. Good, BadNodeIdUnknown)
     */
    statusCode: string;
    /**
     * Server timestamp when the response was generated
     */
    timestamp: Date;
    /**
     * 
     */
    data: HistoryReadResponseData;
    /**
     * 
     */
    meta: HistoryReadResponseMeta;
}

/**
 * Check if a given object implements the HistoryReadResponse interface.
 */
export function instanceOfHistoryReadResponse(value: object): value is HistoryReadResponse {
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function HistoryReadResponseFromJSON(json: any): HistoryReadResponse {
    return HistoryReadResponseFromJSONTyped(json, false);
}

export function HistoryReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'statusCode': json['statusCode'],
        'timestamp': (new Date(json['timestamp'])),
        'data': HistoryReadResponseDataFromJSON(json['data']),
        'meta': HistoryReadResponseMetaFromJSON(json['meta']),
    };
}

export function HistoryReadResponseToJSON(json: any): HistoryReadResponse {
    return HistoryReadResponseToJSONTyped(json, false);
}

export function HistoryReadResponseToJSONTyped(value?: HistoryReadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statusCode': value['statusCode'],
        'timestamp': value['timestamp'].toISOString(),
        'data': HistoryReadResponseDataToJSON(value['data']),
        'meta': HistoryReadResponseMetaToJSON(value['meta']),
    };
}

